export const buildUrl = (
    url: string,
    params: Record<string, string | number | boolean | null | undefined>
) => {
    const urlParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
            urlParams.append(key, value.toString());
        }
    });
    return `${url}?${urlParams.toString()}`;
};
